import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormField, MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Property } from '../../../models/property.model';

@Component({
  selector: 'app-property-details-edit',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormField,
    MatInputModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    FormsModule,
    MatSelectModule,
    MatOptionModule
  ],
  templateUrl: './property-details-edit.html',
  styleUrl: './property-details-edit.scss',
})
export class PropertyDetailsEdit {
  propertyTypes = ['house', 'townhouse', 'apartment', 'condo', 'villa', 'manufactured'];
  @Input() dialogRef?: MatDialogRef<any>;
  readonly data = inject<Property>(MAT_DIALOG_DATA);
  property: Property = { ...this.data };

  @Output()
  private _save = new EventEmitter<Property>();

  public get save() {
    return this._save;
  }
  public set save(value) {
    this._save = value;
  }

  @Output() cancel = new EventEmitter<void>();
}
